import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { Store } from '@ngrx/store'
import { OpenInvoiceOverlay } from '@tv3/store/overlay/overlay.actions'

@Component({
  selector: 'app-invoice-results-table',
  templateUrl: './invoice-results-table.component.html',
  styles: [
    `
      table {
        width: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InvoiceResultsTableComponent implements OnInit {
  @Input() results: any[] = []

  @ViewChild('paginator') set paginator(p: MatPaginator) {
    this.dataSource.paginator = p
  }

  dataSource = new MatTableDataSource<any>()
  displayedColumns = ['title', 'rental', 'invoiceNum', 'dueDate']

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.dataSource.data = this.results || []
  }

  onEdit(invoice: any) {
    this.store.dispatch(OpenInvoiceOverlay({ invoiceId: invoice.pkey }))
  }
}
